import { apiService } from "@/_services";
/**
 * Get Plants for all companies
 * @param { object } companies initial company information
 */
export function getPlants(companies) {
  let plants = [];
  companies.forEach(function(comp) {
    comp["portfolios"].forEach(function(port) {
      plants = plants.concat(port["fk_id_plant"]);
    });
  });
  let params = {
    method: "GET",
    endpoint: "plants",
    query_params: {
      format: "json",
      plants: { id: plants }
    }
  };
  return apiService.getAll(params);
}
